import snakeCase from 'lodash/snakeCase';
import { assertAvailable, resolveDescription } from './toolDefinitionUtils';
export class ToolDefinitionWithMcpOutputImpl {
    constructor(args) {
        this.name = args.name;
        this.title = args.title;
        this.descriptionConfig = args.description;
        this.availability = args.availability;
        this.inputSchema = args.inputSchema;
        this.inputSchemaTransformed = args.inputSchemaTransformed;
        this.mcpConfig = args.mcpConfig;
    }
    get description() {
        return resolveDescription(this.descriptionConfig, this.name);
    }
    for(runtime) {
        assertAvailable(this.name, this.availability, runtime);
        if (runtime === 'agent') {
            return {
                name: this.name,
                title: this.title,
                description: this.description,
                inputSchema: this.inputSchema,
            };
        }
        const mcpName = this.mcpConfig.name ?? snakeCase(this.name);
        return {
            name: mcpName,
            canonicalName: this.name,
            title: this.title,
            description: resolveDescription(this.descriptionConfig, mcpName),
            inputSchema: this.inputSchema,
            annotations: this.mcpConfig.annotations,
            outputSchema: this.mcpConfig.outputSchema,
            meta: this.mcpConfig.meta,
        };
    }
}
//# sourceMappingURL=toolDefinitionWithMcpOutput.js.map